import { combineReducers, configureStore } from '@reduxjs/toolkit';

import {
  objectInfoReducer,
  answersReducer,
  filtersReducer,
  reviewsReducer,
  userReducer,
  questionsReducer,
  modalsReducer,
} from '../../reducers';
import { IApplicationState, IThunkContext } from '../../types/redux';
import { newReviewReducer } from '../../reducers/newReview';
import { newAnswerReducer } from '../../reducers/newAnswer';
import { newQuestionReducer } from '../../reducers/newQuestion';
import { sortReducer } from '../../reducers/sort';
import { tabsReducer } from '../../reducers/tabs';

/**
 * Хелпер для создания Redux стора
 */
export function createReduxStore(preloadedState: IApplicationState, debugEnabled: boolean, context: IThunkContext) {
  const projectName = context.config.getStrict<string>('projectName');

  const reducer = combineReducers({
    objectInfo: objectInfoReducer,
    filters: filtersReducer,
    sort: sortReducer,
    newReview: newReviewReducer,
    newAnswer: newAnswerReducer,
    reviews: reviewsReducer,
    questions: questionsReducer,
    answers: answersReducer,
    user: userReducer,
    newQuestion: newQuestionReducer,
    tabs: tabsReducer,
    modals: modalsReducer,
  });

  const devTools = debugEnabled ? { name: projectName } : false;

  return configureStore({
    devTools,
    preloadedState,
    reducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ thunk: { extraArgument: context } }),
  });
}
